export default __webpack_public_path__ + "static/media/image2.4b30aba5.jpg";